import VueRouter from "vue-router";
//引入一个路由组件
import Home from '../page/Home.vue'
import Electricity from '../page/Electricity.vue'
import PipeNetwork from '../page/PipeNetwork.vue'
import Maintain from '../page/Maintain.vue'
import Monitor from '../page/Monitor.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  routes: [
    {
      path:'',
      // redirect:'/home'
    },
    {
      name: 'home', 
      path: '/home',
      component: Home
    },
    {
      name: 'electricity',
      path: '/electricity',
      component: Electricity
    },
    {
      name: 'pipenetwork',
      path: '/pipenetwork',
      component: PipeNetwork
    },
    {
      name: 'maintain',
      path: '/maintain',
      component: Maintain
    },
    {
      name: 'monitor',
      path: '/monitor',
      component: Monitor
    },
  ]
})